import { useEffect, useState } from "react";
import { api } from "@/api/client";
import type { RecentDoc } from "@/api/types";
import { FileText } from "lucide-react";

// 첫 화면 위젯 — '최근 추가된 자료'만 표시.
// (내 최근 질문·인기 질문 위젯은 제거됨)
// '다가오는 일정'은 안내 문구 아래(첫 화면 맨 끝)에 두므로 Chat 이 직접 렌더한다.
export default function HomeWidgets() {
  const [docs, setDocs] = useState<RecentDoc[]>([]);

  useEffect(() => {
    api.recentDocs().then((r) => setDocs(r.items.slice(0, 6))).catch(() => {});
  }, []);

  if (docs.length === 0) return null;

  return (
    <div className="mx-auto grid w-full max-w-2xl gap-3 text-left">
      <section className="rounded-xl border border-border bg-card p-3">
        <h3 className="mb-2 flex items-center gap-1.5 text-sm font-semibold">
          <FileText className="h-4 w-4 text-[#0E1E2D]" /> 최근 추가된 자료
        </h3>
        <ul className="space-y-1">
          {docs.map((d) => (
            <li key={d.page_id}>
              <a
                href={d.url || "#"}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-2 rounded-md px-2 py-1.5 text-sm hover:bg-muted"
              >
                <span
                  className={
                    "shrink-0 rounded px-1.5 py-0.5 text-[10px] font-semibold " +
                    (d.label === "분야별자료"
                      ? "bg-orange-100 text-orange-700"
                      : "bg-blue-100 text-blue-700")
                  }
                >
                  {d.label === "분야별자료" ? (d.customer || "분야") : "공통"}
                </span>
                <span className="min-w-0 flex-1 truncate">{d.title}</span>
              </a>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}
